<template>
  <div class="bank-edit">
    <el-dialog :title="etype == 1 ? '查看银行认证' : etype == 2 ? '修改银行认证' : '新增银行认证'" :visible.sync="visible" width="600px"
      :before-close="handleClose">
      <el-form ref="form" :model="form" :rules="rules" label-width="120px" v-if="etype != 1">
        <el-form-item label="银行名称" prop="bankName">
          <el-input v-model="form.bankName" placeholder="请输入银行名称"></el-input>
        </el-form-item>
        <el-form-item label="银行部门" prop="bankDepartment">
          <el-input v-model="form.bankDepartment" placeholder="请输入银行部门"></el-input>
        </el-form-item>
        <el-form-item label="职位" prop="position">
          <el-input v-model="form.position" placeholder="请输入职位"></el-input>
        </el-form-item>
        <el-form-item label="联系人姓名" prop="contactPerson">
          <el-input v-model="form.contactPerson" placeholder="请输入联系人姓名"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="contactPhone">
          <el-input v-model="form.contactPhone" placeholder="请输入联系电话"></el-input>
        </el-form-item>
        <el-form-item label="电子邮箱">
          <el-input v-model="form.email" placeholder="请输入电子邮箱"></el-input>
        </el-form-item>
        <el-form-item label="备注信息">
          <el-input type="textarea" v-model="form.remark" placeholder="请输入备注信息"></el-input>
        </el-form-item>
        <el-form-item label="证明材料">
          <el-upload
            class="upload-demo"
            :action="burl + '/api/v1/upload'"
            :on-success="handleProofMaterialSuccess"
            :on-remove="handleProofMaterialRemove"
            :limit="1"
            :file-list="proofMaterialList">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传1份证明材料，文件大小不超过20MB</div>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit('form')">提交</el-button>
          <el-button @click="handleCancel">取消</el-button>
        </el-form-item>
      </el-form>

      <!-- 查看模式 -->
      <div v-if="etype == 1">
        <el-descriptions :column="2" border>
          <el-descriptions-item label="银行名称">{{ form.bankName }}</el-descriptions-item>
          <el-descriptions-item label="银行部门">{{ form.bankDepartment }}</el-descriptions-item>
          <el-descriptions-item label="职位">{{ form.position }}</el-descriptions-item>
          <el-descriptions-item label="联系人姓名">{{ form.contactPerson }}</el-descriptions-item>
          <el-descriptions-item label="联系电话">{{ form.contactPhone }}</el-descriptions-item>
          <el-descriptions-item label="电子邮箱">{{ form.email }}</el-descriptions-item>
          <el-descriptions-item label="状态">
            <el-tag v-if="form.status == 0" type="warning">审核中</el-tag>
            <el-tag v-else-if="form.status == 1" type="success">已通过</el-tag>
            <el-tag v-else-if="form.status == 2" type="danger">未通过</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="备注信息" :span="2">{{ form.remark }}</el-descriptions-item>
          <el-descriptions-item label="证明材料" :span="2">
            <div v-if="form.imageUrl">
              <a
                :href="form.imageUrl"
                target="_blank"
                style="color: #165dff;">
                {{ form.imageUrl.split('/').pop() || '证明材料' }}
              </a>
            </div>
            <span v-else style="color: #86909c;">暂无证明材料</span>
          </el-descriptions-item>
        </el-descriptions>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { postRequest } from "../api/api";
import { baseUrl } from "../api/constant";

export default {
  name: "BankEdit",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    etype: {
      type: Number,
      default: 0, // 0-新增 1-查看 2-修改
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      form: {
        bankName: "",
        bankDepartment: "",
        position: "",
        employeeNumber: "",
        contactPerson: "",
        contactPhone: "",
        email: "",
        remark: "",
        imageUrl: "",
        status: 0,
      },
      proofMaterialList: [],
      rules: {
        bankName: [
          { required: true, message: "请输入银行名称", trigger: "blur" },
        ],
        bankDepartment: [
          { required: true, message: "请输入银行部门", trigger: "blur" },
        ],
        position: [
          { required: true, message: "请输入职位", trigger: "blur" },
        ],
        employeeNumber: [
          { required: true, message: "请输入员工编号", trigger: "blur" },
        ],
        contactPerson: [
          { required: true, message: "请输入联系人姓名", trigger: "blur" },
        ],
        contactPhone: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
          { pattern: /^1[3-9]\d{9}$/, message: "请输入正确的手机号码", trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    burl() {
      return baseUrl;
    },
  },
  watch: {
    visible(val) {
      if (val && this.etype != 0) {
        this.form = { ...this.data };
        // 初始化证明材料列表
        if (this.form.imageUrl) {
          this.proofMaterialList = [{
            name: this.form.imageUrl.split('/').pop(),
            url: this.form.imageUrl,
          }];
        } else {
          this.proofMaterialList = [];
        }
      } else if (val && this.etype == 0) {
        // 新增模式，重置数据
        this.proofMaterialList = [];
        this.form.imageUrl = "";
      }
    },
  },
  methods: {
    handleClose() {
      this.$emit("update:visible", false);
      this.$emit("close");
    },
    handleCancel() {
      this.$emit("update:visible", false);
      this.$emit("close");
    },
    // 证明材料上传成功
    handleProofMaterialSuccess(res, file) {
      if (res.errcode == 200 && res.data) {
        const fileInfo = {
          name: file.name,
          url: res.data.webPath,
        };
        this.proofMaterialList = [fileInfo];
        this.form.imageUrl = res.data.webPath;
      } else {
        this.$message.error("上传失败，请重试");
      }
    },
    // 证明材料移除
    handleProofMaterialRemove(file, fileList) {
      this.proofMaterialList = fileList;
      this.form.imageUrl = fileList.length > 0 ? fileList[0].url : "";
    },
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 构建提交数据
          const submitData = {
            bankName: this.form.bankName,
            bankDepartment: this.form.bankDepartment,
            position: this.form.position,
            employeeNumber: this.form.employeeNumber,
            contactPerson: this.form.contactPerson,
            contactPhone: this.form.contactPhone,
            email: this.form.email,
            remark: this.form.remark,
            imageUrl: this.form.imageUrl,
            status: 0, // 初始状态为审核中
          };

          // 调用 API 提交数据
          postRequest({
            url: "/api/v1/bank-certification",
            data: submitData,
          })
            .then((res) => {
              this.$message.success("提交成功");
              this.$emit("close");
              // 提交成功后跳转到授权中心
              this.$router.push("/my");
            })
            .catch((error) => {
              console.error("提交失败:", error);
              this.$message.error("提交失败，请重试");
            });
        } else {
          return false;
        }
      });
    },

  },
};
</script>

<style lang="scss" scoped>
.bank-edit {
  .upload-demo {
    .el-upload__tip {
      font-size: 12px;
      color: #909399;
      margin-top: 8px;
    }
  }
}
</style>